import Crypto from './crypto/crypto.js';
	import './crypto/hmac.js';
	import './crypto/sha1.js';
	import {
		Base64
	} from './crypto/base64.js';
	import config from '@/common/config.js'
	const uploadFileSize = 1024 * 1024 * 10; // 上传文件的大小限制10m

	export default {
		_getPolicy() {
			let policyText = {
				"expiration": "2040-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
				"conditions": [
					["content-length-range", 0, uploadFileSize] // 设置上传文件的大小限制
				]
			};
			return Base64.encode(JSON.stringify(policyText))
		},
		_getSignature(message) {
			console.log(Crypto.SHA1);
			console.log(message);
			console.log(config.ossConfig);
			let bytes = Crypto.HMAC(Crypto.SHA1, message, config.ossConfig.accessKeySecret, {
				asBytes: true
			});
			return Crypto.util.bytesToBase64(bytes);
		},
		_getSuffix(filename) {
			let pos = filename.lastIndexOf('.')
			let suffix = ''
			if (pos != -1) {
				suffix = filename.substring(pos)
			}
			return suffix;
		},
		_getFullName(filename) {
			console.log(filename)
			let pos = filename.lastIndexOf('/')
			let fullName = ''
			if (pos != -1) {
				fullName = filename.substring(pos+1)
			}
			return fullName;
		},
		getFileName(filename) {
			let curTime = new Date();
			let timestamp = Date.parse(curTime);
			let year = curTime.getFullYear(),
				month = curTime.getMonth() + 1,
				day = curTime.getDate()
			return year + '' + (month < 10 ? '0' + month : month) + '' + (day < 10 ? '0' + day : day) + '/' + timestamp+parseInt(Math.random()*100000) 
		},
		get_STS() {
			return new Promise((resolve, reject) => {
				let policy = this._getPolicy();
				let res = {
					accessId: config.ossConfig.accessKeyId,
					host: config.ossConfig.ossHost,
					policy,
					signature: this._getSignature(policy),
				};
				resolve(res)
			})
		},
	};



// WEBPACK FOOTER //
// ./src/common/Upload_2_OSS/ossUtil.js